<template>
  <div class="w-full">
    <NText>
      {{ t('modules.watchlist.name') }}
    </NText>

    <NInput v-model="title" required class="w-full mt-1" />

    <NButton
      color="green"
      class="w-full"
      @click="emit('edit', { id: watchlist.id, title })"
    >
      {{ t('modules.watchlist.submit_edit_watchlist') }}
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Watchlist } from '@libs/api-reference';

type EditWatchlistDialogEmitsType = {
  (
    e: 'edit',
    data: {
      id: string;
      title: string;
    }
  ): void;
};

type EditWatchlistDialogPropsType = {
  watchlist: Watchlist;
};

const emit = defineEmits<EditWatchlistDialogEmitsType>();

const props = defineProps<EditWatchlistDialogPropsType>();

const title = ref(props.watchlist.title || '');

const { t } = useI18n();
</script>
